module.exports = __webpack_public_path__ + "img/jwlsc.99a6c37e.png";